export default __webpack_public_path__ + "static/media/SWT1430.34I-35657_-20738_0.9988c2d3.jpg";